import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useFeedbackContext } from '../context/FeedbackContext';
import { useUserContext } from '../context/UserContext';

const Token: React.FC = () => {

  const navigate = useNavigate();
  const { user, loginWithCode } = useUserContext();
  const { showMessage, showErrorMessage } = useFeedbackContext();

  const [searchParams] = useSearchParams();
  const [loggingIn, setLoggingIn] = React.useState<boolean>(false);
  const hasExchangedRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    const code = searchParams.get('code');
    // Only attempt exchange if:
    // 1. Code exists in URL
    // 2. User is not already logged in
    // 3. We haven't already attempted exchange (using ref to persist across renders)
    // 4. We're not currently logging in
    if (code && !user && !hasExchangedRef.current && !loggingIn) {
      hasExchangedRef.current = true;
      setLoggingIn(true);
      (async () => {
        const loggedInUser = await loginWithCode(code);
        if (loggedInUser) {
          showMessage(`Logged in as ${loggedInUser.email}`);
          navigate('/', { replace: true });
        }
        else {
          console.error('token callback failed');
          showErrorMessage('Login failed');
          navigate('/login');
        }
        setLoggingIn(false);
      })();
    }
    // If user is already logged in or no code present, go to home
    // Also check hasExchangedRef to avoid navigating away while exchange is in flight
    // (ref updates are synchronous, but loggingIn state may not have committed yet)
    else if (!loggingIn && !hasExchangedRef.current) {
      navigate('/', { replace: true });
    }
  }, [user, loggingIn, loginWithCode, navigate, searchParams, showErrorMessage, showMessage]);

  return (
    <Box justifyContent="center" sx={{ p: 2 }}>
      <Grid item xs={12} id='stashsite-body'>
        <Stack justifyContent="center" alignItems="center" spacing={2}>
          {loggingIn && (
            <>
              <Typography variant="body1" component="h1" gutterBottom>Logging in</Typography>
              <CircularProgress />
            </>
          )}
        </Stack>
      </Grid>
    </Box>
  );
};

export default Token;
